// src/components/LedgerPopup.jsx
import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import { useNavigate } from "react-router-dom";
import ReactDOM from "react-dom";

export default function LedgerPopup({ onClose }) {
  const [parties, setParties] = useState([]);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchParties = async () => {
      try {
        const snap = await getDocs(collection(db, "parties"));
        const docs = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        setParties(docs);
        console.log("🔥 Parties loaded:", docs);
      } catch (err) {
        console.error("Error loading parties:", err);
      }
    };
    fetchParties();
  }, []);

  const handlePartyClick = (party) => {
    onClose();
    console.log("➡️ Navigating with partyId (doc.id):", party.id);
    navigate(`/ledger/${party.id}`);
  };

  // 🔎 filter parties by search text
  const filteredParties = parties.filter((p) =>
    (p.partyName || "").toLowerCase().includes(search.toLowerCase())
  );

  const popupContent = (
    <div
      className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50"
      onClick={onClose} // backdrop click = close
    >
      <div
        className="bg-white w-full max-w-2xl h-[80vh] rounded-2xl shadow-2xl flex flex-col animate-fadeIn"
        onClick={(e) => e.stopPropagation()} // prevent backdrop close
      >
        {/* Header */}
        <div className="flex justify-between items-center bg-gradient-to-r from-indigo-600 to-indigo-500 text-white px-6 py-3 rounded-t-2xl">
          <h2 className="text-lg font-semibold">📒 Ledger Account View</h2>
          <button
            className="text-red-300 hover:text-red-500 text-lg font-bold transition"
            onClick={onClose}
            aria-label="Close"
          >
            ✕
          </button>
        </div>

        {/* Body */}
        <div className="p-6 overflow-y-auto flex-1 space-y-4">
          {/* Search box */}
          <input
            type="text"
            placeholder="🔍 Search party..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full border border-gray-300 rounded-lg px-4 py-2 shadow-sm focus:ring focus:ring-indigo-200 text-sm"
          />

          {/* Party list */}
          <ul className="space-y-2">
            {filteredParties.length > 0 ? (
              filteredParties.map((party) => (
                <li
                  key={party.id}
                  className="p-2 text-sm bg-gray-50 border border-gray-200 rounded-lg cursor-pointer hover:bg-indigo-50 hover:border-indigo-400 focus:ring focus:ring-indigo-200 focus:outline-none transition"
                  onClick={() => handlePartyClick(party)}
                  tabIndex={0}
                  onKeyDown={(e) => e.key === "Enter" && handlePartyClick(party)}
                >
                  <span className="font-medium text-gray-800">
                    {party.partyName}
                  </span>
                </li>
              ))
            ) : (
              <li className="text-gray-500 italic text-sm">No parties found…</li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );

  // Render with Portal
  return ReactDOM.createPortal(popupContent, document.body);
}
